// Citation renders a memory (◇) or episode (◈) reference pill.
// Resolves label from cache; falls back to URN fragment.

import { useMemory } from '../lib/useMemory.js';

function glyphFor(kind) {
  if (kind === 'episode') return '◈';
  if (kind === 'memory') return '◇';
  return null;
}

function labelFrom(data, urn) {
  if (!urn) return '';
  if (!data) return urn.split(':').pop();
  return data?.payload?.label
    || data?.payload?.summary?.slice(0, 60)
    || data?.payload?.text?.slice(0, 60)
    || urn.split(':').pop();
}

function fromText(data, fallback) {
  if (!data) return fallback || '';
  const ts = data?.envelope?.asserted_at || data?.created_at;
  if (!ts) return fallback || '';
  try {
    const d = new Date(ts);
    const now = new Date();
    const diffDays = Math.round((now - d) / 86400000);
    if (diffDays === 0) return 'today';
    if (diffDays === 1) return 'yesterday';
    if (diffDays < 14) return `${diffDays}d ago`;
    return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
  } catch { return fallback || ''; }
}

export function Citation({ urn, kind, label: labelProp, from: fromProp }) {
  if (!urn) return null;
  const resolvedKind = kind
    || (urn?.includes(':episode:') ? 'episode' : 'memory');
  const { data } = useMemory(urn);
  const label = labelProp || labelFrom(data, urn);
  const from = fromText(data, fromProp);
  const glyph = glyphFor(resolvedKind);

  if (!glyph) return <code>{urn}</code>;

  return (
    <span
      className="cx-cite"
      title={urn}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontFamily: 'var(--ff-mono)',
        fontSize: 10,
        padding: '1px 6px',
        border: '1px solid var(--rule)',
        borderRadius: 3,
        color: 'var(--ink-soft)',
        whiteSpace: 'nowrap',
      }}
    >
      <span style={{ opacity: 0.7 }}>{glyph}</span>
      <span>{label}</span>
      {from && <span style={{ opacity: 0.5 }}>· {from}</span>}
    </span>
  );
}
